// extracted by mini-css-extract-plugin
export const meta = "projectTemplate-module--meta--20kti";
export const date = "projectTemplate-module--date--21Zg4";
export const summary = "projectTemplate-module--summary--Kdsbw";
export const featuredImage = "projectTemplate-module--featuredImage--xDPl8";
export const main = "projectTemplate-module--main--3OH6t";